// Central dayjs setup. Plugins must be registered once at module load — they
// extend the shared dayjs instance, so every other file that does
// `import dayjs from "dayjs"` automatically gets these capabilities.
//
// moment had `.fromNow()`, `.format("LL")`, etc. built in. dayjs ships lean
// and you opt into each plugin. The cards/timestamps in this app depend on:
//   - relativeTime  → `.fromNow()`, `.from()`, `.toNow()`
//   - localizedFormat → `.format("LL" | "LLL" | "ll" | ...)`
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);

export default dayjs;
